import PasswordTemplate from 'components/password/PasswordTemplate';

const PasswordPage = () => {
  return <PasswordTemplate />;
};

export default PasswordPage;
